import { createClient } from "@sanity/client";

export const client = createClient({
  projectId: "c5u133mn",   // ✅ correct ID
  dataset: "production",
  apiVersion: "2023-10-01",
  useCdn: true,
  perspective: "published"
});
